import { render } from "./GridOrganigramaDetalii.vue?vue&type=template&id=6251084e&ts=true"
import script from "./GridOrganigramaDetalii.vue?vue&type=script&lang=ts"
export * from "./GridOrganigramaDetalii.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__